module.exports = __webpack_public_path__ + "img/background.aafb4c98.png";